import axios from 'axios';
import baseUrl from '../config/baseURL';
import { getAuthToken } from '../services/auth';

export const updateWhatsAppAbout = async (
  whatsapp_number_id: string,
  organization_id: string,
  about: any,
) => {
  return patchWhatsAppNumber(whatsapp_number_id, organization_id, { about });
};

export const updateWhatsAppEmail = async (
  whatsapp_number_id: string,
  organization_id: any,
  email: string,
) => {
  return patchWhatsAppNumber(whatsapp_number_id, organization_id, { email });
};

export const updateWhatsAppWebsite = async (
  whatsapp_number_id: string,
  organization_id: any,
  website: string,
) => {
  return patchWhatsAppNumber(whatsapp_number_id, organization_id, { website });
};

export const updateWhatsAppAddress = async (
  whatsapp_number_id: string,
  organization_id: any,
  address: string,
) => {
  return patchWhatsAppNumber(whatsapp_number_id, organization_id, { address });
};

export const updateAIChatResponses = async (
  whatsapp_number_id: string,
  organization_id: any,
  ai_chat_responses: boolean,
) => {
  return patchWhatsAppNumber(whatsapp_number_id, organization_id, {
    ai_chat_responses,
  });
};

export const updateWhatsAppProfilePhoto = async (
  whatsapp_number_id: string,
  organization_id: any,
  profile_photo: File,
) => {
  const formData = new FormData();
  formData.append('profile_photo', profile_photo);
  return patchWhatsAppNumber(whatsapp_number_id, organization_id, formData, true);
};

export const patchWhatsAppNumber = async (
  whatsapp_number_id: any,
  organization_id: any,
  payload: Record<string, any> | FormData,
  isMultipart = false,
) => {
  let token = await getAuthToken();

  if (!token) {
    return { success: false, data: 'error: Token does not exist' };
  }

  try {
    const headers: Record<string, string> = { Authorization: `Bearer ${token.data}` };
    if (!isMultipart) {
      headers['Content-Type'] = 'application/json';
    }
    const endpoint = `${baseUrl}/core/organizations/${organization_id}/whatsapp-number/${whatsapp_number_id}/`;

    const response = await axios.patch(endpoint, payload, { headers });

    return {
      success: response.status >= 200 && response.status <= 400,
      data: response.data,
    };
  } catch (error) {
    console.error('WhatsApp patch failed:', error);
    return { success: false, data: error };
  }
};
